import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { BlobServiceClient } from "@azure/storage-blob";
import GenericPdf from "../../InvoicePdfTemplates/GenericPdf/GenericPdf";
import { DropDown, TableLoader } from "../../../commons";
import { NewWhiteDownloadIcon } from "../../../../assets/images";
import GenericRasPolypackPdf from "../../InvoicePdfTemplates/GenericPdf/GenericRasPolypackPdf";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import DynamicPdf from "../../InvoicePdfTemplates/DynamicPdf/DynamicPdf";
import LongDeclaration from "../../InvoicePdfTemplates/LongDeclaration/LongDeclarationTemplate";
import GstSummaryWithoutSku from "../../InvoicePdfTemplates/GstSummaryWithoutSku/GstSummaryPdf";
import BatchSummary from "../../InvoicePdfTemplates/BatchSummaryPdf/index"
import GenericRasPolypackWithoutNa from "../../InvoicePdfTemplates/GenericPdf/GenericRasPolypackWithoutNa";



type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  currencySign: string | undefined;
  pdfInvoiceId: number | null;
  customerSingleInvoiceData: any;
  clientCode: number;
  pdfTemplatesNames: OptionsType[] | []
  pdfTemplateSelected: OptionsType
  setPdfTemplateSelected: React.Dispatch<React.SetStateAction<OptionsType>>;
  currencyShortForm: string | undefined;
};

const RevenuePdfPreviewModal = ({
  modal,
  toggleModal,
  currencySign,
  customerSingleInvoiceData,
  pdfInvoiceId,
  clientCode,
  pdfTemplatesNames,
  pdfTemplateSelected,
  setPdfTemplateSelected,
  currencyShortForm,
}: AppProps) => {
  const [loading, setLoading] = useState(true);


  const handleOptionChange = (e: OptionsType) => {
    if (pdfTemplateSelected?.value !== e?.value) {
      setPdfTemplateSelected(e)
    }
  };

  const handleTemplateType = (type: string) => {
    switch (type) {
      case "Ras Polypack": return <GenericRasPolypackPdf
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      case "Dynamic Primary": return <GenericRasPolypackWithoutNa
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      case "Generic Pdf": return <GenericPdf
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      case "Dynamic Pdf": return <DynamicPdf
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      case "Long Declaration": return <LongDeclaration
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      case "GST Summary Without SKU": return <GstSummaryWithoutSku
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />
      case "Batch Summary": return <BatchSummary
        downloadRevenuesData={updatedCustomerSingleInvoiceData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
      />

      default:
        return <></>;
    }
  }



  let updatedCustomerSingleInvoiceData = {};
  //currency conversion for single invoice item data
  const updatedCustomerSuplierItemData: any[] = [];
  customerSingleInvoiceData?.item_details &&
    customerSingleInvoiceData?.item_details?.map((el: any) => {
      let replaceObject = {};

      for (let key in el) {
        if (key === "currency_amount_details") {
          replaceObject = { ...el[key] };
          break;
        }
      }
      const updatedObject = {
        ...el,
        ...replaceObject,
      };

      delete updatedObject.currency_amount_details;
      updatedCustomerSuplierItemData.push(updatedObject);
    });
  updatedCustomerSingleInvoiceData = {
    ...customerSingleInvoiceData,
    ...customerSingleInvoiceData?.currency_amount_details,
    item_details: updatedCustomerSuplierItemData,
  };

  return (
    <Modal isOpen={modal} toggle={toggleModal} size={"xl"}>
      <ModalHeader toggle={toggleModal}>
        {customerSingleInvoiceData?.primary_details?.document_type?.label
          ? customerSingleInvoiceData?.primary_details?.document_type?.label
          : "Invoice Preview"}
      </ModalHeader>
      <ModalBody>

        <div>
          <div>
            {<div style={{ width: "15%", marginBottom: "-45px" }}>
              <DropDown
                options={[...pdfTemplatesNames]}
                handleChange={(e: OptionsType) => handleOptionChange(e)}
                value={pdfTemplateSelected}
              />
            </div>}
          </div>
          {!!customerSingleInvoiceData &&
            Object.keys(customerSingleInvoiceData)?.length ? (
            <div style={{ display: "inline-block", marginLeft: "88%", marginTop: "5px" }}>

              <PDFDownloadLink
                document={
                  handleTemplateType(pdfTemplateSelected?.label)
                }
                fileName={`${customerSingleInvoiceData?.primary_details?.document_type
                  ?.value
                  ? customerSingleInvoiceData?.primary_details?.document_type
                    ?.label
                  : ""
                  }${customerSingleInvoiceData?.primary_details?.document_type
                    ?.value &&
                    customerSingleInvoiceData?.primary_details
                      ?.voucher_invoice_number != null
                    ? "_"
                    : ""
                  }${customerSingleInvoiceData?.primary_details
                    ?.voucher_invoice_number != null
                    ? customerSingleInvoiceData?.primary_details
                      ?.voucher_invoice_number
                    : ""
                  }.pdf`}
              >
                {({ blob, url, loading, error }) => {
                  // Handle loading and error states if needed
                  if (loading) {

                    return <div style={{ width: "84vw", marginLeft: "-88%", marginTop: "60px" }}>
                      <TableLoader Rows={10} ColumnPerRow={4} />;
                    </div>
                  }

                  if (error) {
                    setLoading(false);
                    return (
                      <span className="radio-container-vertical">
                        Error loading PDF
                      </span>
                    );
                  } else if (url?.length) {
                    setLoading(false);
                    return (
                      <div>
                        <button className="btn btn-primary">
                          <span className="pr-2">
                            <img src={NewWhiteDownloadIcon} alt="download" />
                          </span>
                          Download
                        </button>
                      </div>
                    );
                  }
                }}
              </PDFDownloadLink>
            </div>
          ) : null}

          <div className="mt-4 mb-5 ml-2" style={{ width: "100%" }}>
            {!!updatedCustomerSingleInvoiceData &&
              !loading &&
              Object.keys(updatedCustomerSingleInvoiceData)?.length ? (
              <PDFViewer
                showToolbar={false}
                style={{ width: "100%", height: "100vh" }}
              >
                {handleTemplateType(pdfTemplateSelected?.label)}
              </PDFViewer>
            ) : null}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="text-right d-flex">
          <span className="pointer form-control" onClick={toggleModal}>
            Cancel
          </span>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default RevenuePdfPreviewModal